import { useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { WidthCalculation } from "./SizeCaluculation";

/**
 * CampusMapコンポーネント
 * 
 * このコンポーネントはキャンパスマップを表示するためのもので、
 * SVG画像を中央に表示し、ユーザーが自由に拡大・縮小・パン（移動）できるようになっています。
 * 
 * 主な機能:
 * - `react-zoom-pan-pinch` ライブラリを使用して、マウスホイールやタッチ操作によるズーム・パンに対応
 * - デフォルトの表示倍率は1（100%）、最大3倍、最小0.5倍まで制限
 * - 縦画面では幅100%、横画面では幅80%で表示
 * - レスポンシブ対応のため、`WidthCalculation` 関数で画像サイズを動的に決定
 * - ダブルクリックによるズームは無効化
 * 
 * 注意:
 * - このコンポーネントでは、他の画面で無効化しているズーム操作を許可しています。
 */

const CampusMap = () => {
    const [width] = useState<number>(WidthCalculation(1300, 1300));

    return (
        <div
            style={{
                position: "absolute",
                width: window.innerHeight > window.innerWidth ? "100%" : "80%",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
                touchAction: "none",
            }}
        >
            <TransformWrapper
                initialScale={1}
                wheel={{ step: 0.1 }}
                doubleClick={{ disabled: true }}
                pinch={{ step: 5 }}
                zoomAnimation={{ animationTime: 300 }}
                minScale={0.5}
                maxScale={3}
            >
                <TransformComponent>
                    <img
                        src="/svg/campus-map.svg"
                        alt="Campus Map"
                        style={{ width: width, maxWidth: "none" }}
                    />
                </TransformComponent>
            </TransformWrapper>
        </div>
    );
};

export default CampusMap;